<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import frameTypeEnum from '../enums/frameType'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                inspectionForm: () => import('../forms/InspectionForm'),
                fields: [
                    { type: 'autocomplete', text: 'Inspection', value: 'inspectionId', rules: [v => !!v || 'Inspection is required'], isRequired: true, form: () => import('./InspectionForm'), apiMethod: 'Inspections', claim: 'Inspections' },
                    { type: 'number', text: 'Number Of Frames', value: 'numberOfFrames', rules: [v => (v !== null && v !== '') || 'Number Of Frames is required'], isRequired: true },
                    { type: 'enum', text: 'Frame Type', value: 'frameType', rules: [v => (v !== null && v !== '') || 'Frame Type is required'], isRequired: true, items: enumService.enumAsSelectList(frameTypeEnum) },
                ],
                apiMethod: 'Nucs',
                formTitle: 'Nuc',
            }
        },
    };
</script>
